// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1R3xV","box":"WorkspacesBox_box__38mPl","node":"WorkspacesBox_node__1ah35"};